import { Box, Chip, Divider, Link, Typography } from "@mui/joy";
import { useMissionMap } from "../templates/projectInvite";
import { show } from "@intercom/messenger-js-sdk";

function getContrastYIQ(hexcolor: string) {
  const r = parseInt(hexcolor.substring(1, 3), 16);
  const g = parseInt(hexcolor.substring(3, 5), 16);
  const b = parseInt(hexcolor.substring(5, 7), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? "black" : "white";
}

export function Footer({ token }: { token: string }) {
  const mission = useMissionMap(token);

  const color = getContrastYIQ(mission?.CompanyColor ?? "#000000");

  return (
    <Box
      sx={{
        textAlign: "center",
        color: color,
        pb: 8,
        pt: 2,
        background: mission?.CompanyColor,
      }}
    >
      <Box
        sx={{ display: "flex", gap: 1, justifyContent: "center", opacity: 0.7 }}
      >
        <Typography
          level="body-md"
          sx={{ color: "inherit" }}
          endDecorator={
            <img
              onClick={() => window.open("https://www.rhapsody.la")}
              src={"https://storage.googleapis.com/rhapsody/Avatars/logo.svg"}
              style={{
                height: 25,
                cursor: "pointer",
                filter: color === "black" ? "invert(100%)" : undefined,
              }}
            />
          }
        >
          <b>
            <i>Powered by</i>
          </b>{" "}
        </Typography>
      </Box>
      <Typography
        level="body-xs"
        sx={{ color: "inherit", mt: 1, opacity: 0.7 }}
      >
        You received this email because of {mission?.CompanyName}
        &apos;s account with Rhapsody.
        <br />
        If you no longer wish to receive Rhapsody calls from{" "}
        {mission?.CompanyName}, please contact them directly.
        <br />
        <Divider sx={{ mt: 1, mb: 1, background: color, opacity: 0.2 }} />
        Developed with love in Los Angeles, CA
        <br />
        <Link sx={{ color: "inherit" }} href="https://www.rhapsody.la">
          www.rhapsody.la
        </Link>
      </Typography>
      <Chip
        size="sm"
        onClick={() => window.location.replace("https://rhapsody.la/referral")}
        variant="outlined"
        endDecorator={
          <Typography
            sx={{
              borderRadius: 8,
              m: 0.5,
              background: "white",
              fontSize: 10,
            }}
            level="body-sm"
            variant="outlined"
          >
            Join now
          </Typography>
        }
        sx={{
          lineHeight: 1,
          mt: 1,
        }}
        startDecorator={
          <Typography level="title-lg" sx={{ fontSize: 20 }}>
            🤝
          </Typography>
        }
      >
        <Box>
          Refer Rhapsody and earn up to <b>$500</b>
        </Box>
      </Chip>
      <br />
      <br />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 1,
          alignItems: "center",
        }}
      >
        <Link
          startDecorator={<i className="fa-brands fa-instagram"></i>}
          sx={{ color: "inherit", opacity: 0.7 }}
          level="body-xs"
          href="https://www.instagram.com/rhapsody_la/"
        >
          Follow us on Instagram
        </Link>
        <Divider
          orientation="vertical"
          sx={{ background: color, opacity: 0.2 }}
        />
        <Link
          startDecorator={<i className="fa-regular fa-comment"></i>}
          sx={{ color: "inherit", opacity: 0.7 }}
          onClick={show}
          level="body-xs"
        >
          Chat with Support
        </Link>
      </Box>
    </Box>
  );
}
